import * as React from "react";
import { MapContext } from "react-mapbox-gl";

const isTouchEvent = e => e.originalEvent && "touches" in e.originalEvent;
const isTwoFingerTouch = e => e.originalEvent.touches.length >= 2;

export default function Mobile() {
  const map = React.useContext(MapContext);

  const dragStart = event => {
    if (isTouchEvent(event) && !isTwoFingerTouch(event)) {
      map.dragPan.disable();
    }
  };

  const touchStart = event => {
    if (isTouchEvent(event) && isTwoFingerTouch(event)) {
      map.dragPan.enable();
    }
  };

  React.useEffect(() => {
    if (map) {
      map.on("dragstart", dragStart);

      // Drag events not emited after dragPan disabled, so I use touch event here
      map.on("touchstart", touchStart);
    }

    return () => {
      if (map) {
        map.off("dragstart", dragStart);
        map.off("touchstart", touchStart);
      }
    };
  }, [map]);
  return null;
}
